import React from 'react';
import styled from 'styled-components';
import { TextBlock } from '../../components/text';
import { RecapPageI18n } from '../../i18n';

export const LegalNotesText = () => (
    <ul>
        <li><Text>{RecapPageI18n.supplier}</Text></li>
        <li style={{ marginTop: '8px' }}><Text>{RecapPageI18n.office}</Text></li>
        <li style={{ marginTop: '8px' }}><Text>{RecapPageI18n.contacts}</Text></li>
        <li style={{ marginTop: '8px' }}><Text>{RecapPageI18n.iva}</Text></li>
        <li style={{ marginTop: '8px' }}><Text>{RecapPageI18n.conduct}</Text></li>
        <li style={{ marginTop: '8px' }}><Text>{RecapPageI18n.contractMode}</Text></li>
        <li style={{ marginTop: '8px' }}><Text>{RecapPageI18n.contractAvailability}</Text></li>
    </ul>
);

const Text = styled(TextBlock)`

`